import { createAction, props } from '@ngrx/store';
import { CourseSearch } from '../../models/course-search.models';

import {
	SingleClearingCourseSearchUni,
	SingleCourseSearchUni,
} from '../../models/single-uni-course-search.models';
import { ClearingCourseSearch } from '../../models/clearing-course-search.models';
import { CourseSearchFilterPill } from '../../models/course-search-filter.models';
import {
	CourseSearchPayload,
	UniversityCourseSearchPayload,
} from '../../models/course-search-payload.models';

const actionIdentifier = '[Course Search]';
const actionApiIdentifier = '[Course Search API]';

export const updateNotFoundError = createAction(
	`${actionIdentifier} Update not found error`,
	props<{ error: any }>(),
);

//courses
export const fetchCourses = createAction(`${actionApiIdentifier} Fetch courses`);

export const updateCourses = createAction(
	`${actionIdentifier} Update courses`,
	props<{ courses: CourseSearch }>(),
);

export const fetchPaginatedCourses = createAction(
	`${actionApiIdentifier} Fetch paginated courses`,
);

export const updatePaginatedCourses = createAction(
	`${actionIdentifier} Update paginated courses`,
	props<{ courses: CourseSearch }>(),
);

export const fetchUniCourses = createAction(`${actionApiIdentifier} Fetch uni courses`);

export const updateUniCourses = createAction(
	`${actionIdentifier} Update university courses`,
	props<{ uni: SingleCourseSearchUni }>(),
);

export const fetchPaginatedUniCourses = createAction(
	`${actionApiIdentifier} Fetch paginated uni courses`,
);

export const updatePaginatedUniCourses = createAction(
	`${actionIdentifier} Update paginated university courses`,
	props<{ uni: SingleCourseSearchUni }>(),
);

// clearing
export const fetchClearingCourses = createAction(
	`${actionApiIdentifier} Fetch clearing courses`,
);

export const updateClearingCourses = createAction(
	`${actionIdentifier} Update clearing courses`,
	props<{ clearingCourses: ClearingCourseSearch }>(),
);

export const updateClearingCourseSearchUni = createAction(
	`${actionIdentifier} Update clearing university courses`,
	props<{ clearingUni: SingleClearingCourseSearchUni; mergeCourses: boolean }>(),
);

export const updateCourseSearchPayload = createAction(
	`${actionIdentifier} Update course search payload`,
	props<{ payload: Partial<CourseSearchPayload> }>(),
);

export const updateUniCourseSearchPayload = createAction(
	`${actionIdentifier} Update university course search payload`,
	props<{ payload: Partial<UniversityCourseSearchPayload> }>(),
);

export const updateFilterPills = createAction(
	`${actionIdentifier} Update filter pills`,
	props<{ pills: CourseSearchFilterPill[] }>(),
);

export const removeFilterPill = createAction(
	`${actionIdentifier} Remove filter pill`,
	props<{ pill: CourseSearchFilterPill | null }>(),
);

//error
export const updateCourseSearchError = createAction(
	`${actionIdentifier} Update course error`,
	props<{ error: any }>(),
);
